import { createSelector } from 'reselect';

const selectReports = (state) => state.reports;

const selectCouponsTransactions = createSelector(
	selectReports,
	(reports) => reports?.couponsTransactions
);

const selectCouponsTransactionsOverview = createSelector(
	selectReports,
	(reports) => reports?.couponsTransactionsOverview
);

const selectPaymentRequestTransactions = createSelector(
	selectReports,
	(reports) => reports?.paymentRequestTransactions
);

const selectPaymentRequestTransactionsOverview = createSelector(
	selectReports,
	(reports) => reports?.paymentRequestTransactionsOverview
);
const selectTransactionsPackageList = createSelector(
	selectReports,
	(reports) => reports?.transactionPackageList
);
const selectChartPackageList = createSelector(
	selectReports,
	(reports) => reports?.chartPackageList
);
const selectChartPackageOffcbList = createSelector(
	selectReports,
	(reports) => reports?.chartPackageOffcbList
);
const selectTransactionsPackageOffcbList = createSelector(
	selectReports,
	(reports) => reports?.transactionPackageOffcb
);

const reportsSelectors = {
	selectReports,
	selectCouponsTransactions,
	selectCouponsTransactionsOverview,
	selectPaymentRequestTransactions,
	selectPaymentRequestTransactionsOverview,
	selectTransactionsPackageList,
	selectChartPackageList,
	selectChartPackageOffcbList,
	selectTransactionsPackageOffcbList,
};

export default reportsSelectors;
